import { PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist';
import { PDFError } from '../pdf/types';
import '../pdf/worker';

export async function extractTextFromPDF(pdfFile: File): Promise<string> {
  if (!pdfFile?.type?.includes('pdf')) {
    throw new PDFError('Please upload a valid PDF file', 'INVALID_FILE_TYPE');
  }

  let pdf = null;
  try {
    const arrayBuffer = await pdfFile.arrayBuffer();
    if (!arrayBuffer) {
      throw new PDFError('Failed to read PDF file', 'FILE_READ_ERROR');
    }

    const pdfDataArray = new Uint8Array(arrayBuffer);
    
    pdf = await pdfjsLib.getDocument({
      data: pdfDataArray,
      standardFontDataUrl: `https://cdn.jsdelivr.net/npm/pdfjs-dist@4.0.379/standard_fonts/`,
      useSystemFonts: true,
      useWorkerFetch: false,
      isEvalSupported: false,
      canvasMaxAreaInBytes: 100 * 1024 * 1024 // Increase canvas size limit
    }).promise;

    let fullText = '';
    const numPages = pdf.numPages;
    
    for (let i = 1; i <= numPages; i++) {
      const page = await pdf.getPage(i);
      const content = await page.getTextContent();
      const textItems = content.items.map((item: any) => item.str);
      fullText += textItems.join(' ') + '\n';
    }

    return fullText.trim();
  } catch (error) {
    console.error('PDF processing error:', error);
    throw new PDFError(
      'Failed to process the PDF. Please ensure the file is not corrupted.',
      'PDF_PROCESSING_ERROR',
      error
    );
  } finally {
    if (pdf?.destroy) {
      await pdf.destroy().catch(console.error);
    }
  }
}